import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody } from 'reactstrap';

//Componentes auxiliares:
import SourceSelector from './components/SourceSelector';
import SourceJsonUpdater from './components/SourceJsonUpdater';
import EquivalencesUpdater from './components/EquivalencesUpdater';

class SourcesManager extends React.Component {

    constructor() {
        super();

        this.state = {
            downloadSources: [],
            activeDownloadSource: {}
        }
    }

    render() {
        return (
            <Row>
                <Col xs="12" md="5" lg="4" xl="4">
                    <Card data-tut="reactour__sourcesConfiguration.sourceSelector">
                        <CardBody>
                            <SourceSelector
                                downloadSources={this.state.downloadSources}
                                activeDownloadSource={this.state.activeDownloadSource}
                                setNewActiveDownloadSource={this.setNewActiveDownloadSource} />
                            
                        </CardBody>
                    </Card>

                    <Card data-tut="reactour__sourcesConfiguration.equivalencesUpdater">
                        <CardBody>
                            <EquivalencesUpdater
                                activeDownloadSource={this.state.activeDownloadSource} />
                        </CardBody>
                    </Card>
                </Col>

                <Col xs="12" md="7" lg="8" xl="8" style={{ overflow: "hidden" }}>
                    <Card data-tut="reactour__sourcesConfiguration.JSONUpdaterContainer">
                        <CardBody style={{ backgroundColor: "#FAFAFA", borderRadius: 15 }}>
                            <SourceJsonUpdater
                                activeDownloadSource={this.state.activeDownloadSource} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    componentDidMount() {
        this.fetchDownloadSourcesFromBackend();
    }

    //Métodos operativos:
    fetchDownloadSourcesFromBackend = () => {
        window.document.body.style.cursor = "wait";
        fetch(process.env.REACT_APP_API_URL + "/sources/", {
            method: 'GET',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken }
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        serverResponse.json()
                            .then(downloadSources => {
                                const urlParams = new URLSearchParams(window.location.search);
                                let targetDownloadSourceId = urlParams.get("source_id");
                                
                                downloadSources = downloadSources.filter(item =>
                                    item.country_scope === this.props.activeUser.country_scope);

                                let newActiveDownloadSource = downloadSources[downloadSources.length - 1];
                                
                                if (targetDownloadSourceId) {
                                    targetDownloadSourceId = parseInt(targetDownloadSourceId);
                                    newActiveDownloadSource = downloadSources.find(source => source.id === targetDownloadSourceId);
                                }

                                this.setState({
                                    activeDownloadSource: newActiveDownloadSource,
                                    downloadSources: downloadSources.sort((a, b) => (a.id < b.id) ? -1 : 1)
                                });
                            })
                            .catch(error => { console.log(error); });
                        break;

                    default:
                        console.log("Error descargando los sources desde backend...");
                        break;
                }

                window.document.body.style.cursor = "default";
            })
            .catch(error => { console.log(error); window.document.body.style.cursor = "default"; });
    }

    setNewActiveDownloadSource = (newActiveDownloadSource) => {
        this.setState({ activeDownloadSource: newActiveDownloadSource });
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost
    };
};

export default connect(mapStateToProps)(SourcesManager);